import Immutable from 'immutable';

export const actionTypes = {
  SHOW_UNIQUE_OVERLAY: 'edrolo/edrolo/SHOW_UNIQUE_OVERLAY',
  HIDE_UNIQUE_OVERLAY: 'edrolo/edrolo/HIDE_UNIQUE_OVERLAY',
  HIDE_ALL_UNIQUE_OVERLAYS: 'edrolo/edrolo/HIDE_ALL_UNIQUE_OVERLAYS',
};

const defaultState = Immutable.Map({
  activeUniqueOverlayId: null,
  currentPopoverRef: null,
});

// Main Reducer export
export default (state = defaultState, { type, payload }) => {
  switch (type) {
    case actionTypes.SHOW_UNIQUE_OVERLAY:
      return state.set('activeUniqueOverlayId', payload.id);

    case actionTypes.HIDE_UNIQUE_OVERLAY:
      if (state.get('activeUniqueOverlayId') === payload.id) {
        return state.set('activeUniqueOverlayId', null);
      }
      return state;

    case actionTypes.HIDE_ALL_UNIQUE_OVERLAYS:
      return state.set('activeUniqueOverlayId', null);

    case actionTypes.SET_DOCUMENT_TITLE:
      return state.set('documentTitle', payload.title);

    default:
      return state;
  }
};

const overlayControl = {
  showUniqueOverlay: (id) => ({
    type: actionTypes.SHOW_UNIQUE_OVERLAY,
    payload: { id },
  }),
  hideUniqueOverlay: (id) => ({
    type: actionTypes.HIDE_UNIQUE_OVERLAY,
    payload: { id },
  }),
  hideAllUniqueOverlays: () => ({
    type: actionTypes.HIDE_ALL_UNIQUE_OVERLAYS,
  }),
};

export const actions = {
  overlayControl,
};

export const selectors = {
  getCurrentPopover: (state) => state.edrolo.get('currentPopoverRef'),
};
